import Spinner from '../../components/layout/Spinner';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import {
  inputFields,
  LINK_URL,
  PAGE_SINGLE_TITLE,
  PAGE_TITLE,
} from '../../shared/enums/employees_enum';
import { useSingleEmployee } from '../../shared/hooks/UseEmployee';
import AllActivityComponent from './AllActivityComponent';
import EnhancedProfileSingleView from './view-employee/Profile-Single-View';
const ViewEmployee = ({ match }) => {
  const [data] = useSingleEmployee(match.params.id);
  const { employee_loading, employee } = data;
  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink='View'
        />
        {!employee_loading ? (
          employee && (
            <EnhancedProfileSingleView
              data={employee}
              inputFields={inputFields}
              label={PAGE_SINGLE_TITLE}
              link={LINK_URL}
              id={employee._id}
            />
          )
        ) : (
          <div></div>
        )}

        {!employee_loading ? (
          employee && (
            <>
              <AllActivityComponent employee={employee} />
            </>
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewEmployee;
